import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageVersionCreateMutationVariables = Types.Exact<{
  input: Types.CreateThemePageVersionInput;
  themePageID: Types.Scalars['ID']['input'];
}>;

export type ThemePageVersionCreateMutationResponse = {
  themePageVersionCreate?: Types.Maybe<Pick<Types.ThemePageVersion, 'id'>>;
};

export const ThemePageVersionCreateDocument = `
    mutation ThemePageVersionCreate($input: CreateThemePageVersionInput!, $themePageID: ID!) {
  themePageVersionCreate(input: $input, themePageID: $themePageID) {
    id
  }
}
    `;

export const useThemePageVersionCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePageVersionCreateMutationResponse,
    TError,
    ThemePageVersionCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePageVersionCreateMutationResponse,
    TError,
    ThemePageVersionCreateMutationVariables,
    TContext
  >(
    ['ThemePageVersionCreate'],
    (variables?: ThemePageVersionCreateMutationVariables) =>
      appFetcher<ThemePageVersionCreateMutationResponse, ThemePageVersionCreateMutationVariables>(
        ThemePageVersionCreateDocument,
        variables,
      )(),
    options,
  );
};

useThemePageVersionCreateMutation.getKey = () => ['ThemePageVersionCreate'];
